var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState, useContext, } from "react";
import { AuthorizeFactory } from "../components/Authorize";
import { updateAuthConfig } from "../config";
import { forceTokenRefresh, loginUserThroughRedirect, loginUserWithPasswordFactory, authenticateSilentlyFactory, logoutUser, } from "../fetchingToken";
import { LOGOUT_STORAGE_EVENT_KEY } from "../fetchingToken/auth";
import { calculateDateDiffInSeconds } from "../helperFunctions/date";
import { ApiErrorCode, LoginError, } from "../types";
import AuthenticateFactory from "./Authenticate";
// Number of seconds since logout that automatic login should be disabled
var DISABLE_SILENT_AUTHENTICATE_WINDOW_IN_SECONDS = 5;
function shouldLoginSilently() {
    var logoutTime = window.localStorage.getItem(LOGOUT_STORAGE_EVENT_KEY);
    if (!logoutTime) {
        return true;
    }
    var lastLogoutTime = new Date(logoutTime);
    if (Number.isNaN(lastLogoutTime.getTime())) {
        return true;
    }
    var secondsSinceLastLogin = calculateDateDiffInSeconds(lastLogoutTime, new Date());
    return secondsSinceLastLogin > DISABLE_SILENT_AUTHENTICATE_WINDOW_IN_SECONDS;
}
export function AuthProviderFactory(idTokenStringToUser) {
    var _this = this;
    var authenticateSilently = authenticateSilentlyFactory(idTokenStringToUser);
    var loginUserWithPassword = loginUserWithPasswordFactory(idTokenStringToUser);
    var AuthContext = createContext({
        isAuthenticated: false,
        user: null,
        authenticationCode: null,
        isLoading: true,
        login: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); },
        logout: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); },
        forceRefresh: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); },
    });
    var useAuthContext = function () { return useContext(AuthContext); };
    function AuthProvider(_a) {
        var _this = this;
        var children = _a.children, authConfig = _a.config;
        var _b = useState({
            isLoading: true,
            isAuthenticated: false,
            user: null,
            authenticationCode: null,
        }), authContextState = _b[0], setAuthContextState = _b[1];
        updateAuthConfig(authConfig);
        useEffect(function () {
            var initAuth = function () { return __awaiter(_this, void 0, void 0, function () {
                var user, e_1, errors, loginUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!shouldLoginSilently()) {
                                setAuthContextState({
                                    isAuthenticated: false,
                                    isLoading: false,
                                    user: null,
                                    authenticationCode: null,
                                });
                                return [2 /*return*/];
                            }
                            user = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, authenticateSilently()];
                        case 2:
                            user = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            errors = JSON.stringify(e_1);
                            if (!!errors && errors.includes(ApiErrorCode.CmpOfacError)) {
                                loginUrl = authConfig.loginUrl;
                                window.location.replace(loginUrl + "?login_error=" + LoginError.OFACNonCompliant);
                                return [2 /*return*/];
                            }
                            return [3 /*break*/, 4];
                        case 4:
                            if (user) {
                                setAuthContextState({
                                    isAuthenticated: true,
                                    isLoading: false,
                                    user: user,
                                    authenticationCode: null,
                                });
                            }
                            else {
                                setAuthContextState({
                                    isAuthenticated: false,
                                    isLoading: false,
                                    user: null,
                                    authenticationCode: null,
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            initAuth();
        }, [authConfig]);
        function login(_a) {
            var username = _a.username, password = _a.password, externalLoginUrl = _a.externalLoginUrl;
            return __awaiter(this, void 0, void 0, function () {
                var user;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(!!username && !!password)) return [3 /*break*/, 2];
                            return [4 /*yield*/, loginUserWithPassword({ username: username, password: password })];
                        case 1:
                            user = _b.sent();
                            // TODO: _addUserToLogRocketSession(user); Or maybe client should be responsible for this?
                            // TODO: _addUserToSplitIOSession(user); Or maybe client should be responsible for this?
                            if (user) {
                                setAuthContextState({
                                    isAuthenticated: true,
                                    isLoading: false,
                                    user: user,
                                    authenticationCode: null,
                                });
                            }
                            else {
                                setAuthContextState({
                                    isAuthenticated: false,
                                    isLoading: false,
                                    user: null,
                                    authenticationCode: null,
                                });
                            }
                            return [2 /*return*/];
                        case 2:
                            if (externalLoginUrl) {
                                loginUserThroughRedirect(externalLoginUrl);
                                // Login button will show a spinner until this function is resolved.
                                // We want to show a spinner until the user is redirected, but we can't know exactly how long
                                // that takes.
                                // Redirecting will unload everything so this error will never be shown UNLESS redirecting takes more than
                                // 10 seconds (which should not be impossible but you never know...)
                                return [2 /*return*/, new Promise(function (_res, rej) {
                                        setTimeout(function () { return rej("Login using External Identity Provider failed."); }, 10000);
                                    })];
                            }
                            return [2 /*return*/, Promise.reject("Either username+password or link to external identity provider must be provided for login")];
                    }
                });
            });
        }
        function forceRefresh() {
            return __awaiter(this, void 0, void 0, function () {
                var latestAuthTokens, user;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!authContextState.isAuthenticated) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, forceTokenRefresh()];
                        case 1:
                            latestAuthTokens = _a.sent();
                            user = idTokenStringToUser(latestAuthTokens.idToken);
                            if (user) {
                                setAuthContextState({
                                    isAuthenticated: true,
                                    isLoading: false,
                                    user: user,
                                    authenticationCode: null,
                                });
                            }
                            else {
                                setAuthContextState({
                                    isAuthenticated: false,
                                    isLoading: false,
                                    user: null,
                                    authenticationCode: null,
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function logout(disableRedirect) {
            if (disableRedirect === void 0) { disableRedirect = false; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, logoutUser(authContextState.user, { shouldRedirect: !disableRedirect })];
                        case 1:
                            _a.sent();
                            if (disableRedirect) {
                                setAuthContextState({
                                    isAuthenticated: false,
                                    isLoading: false,
                                    user: null,
                                    authenticationCode: null,
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        return (_jsx(AuthContext.Provider, __assign({ value: __assign({ login: login,
                logout: logout,
                forceRefresh: forceRefresh }, authContextState) }, { children: children }), void 0));
    }
    var Authenticate = AuthenticateFactory(useAuthContext);
    var _a = AuthorizeFactory(useAuthContext), Authorize = _a.Authorize, withAuthorize = _a.withAuthorize;
    return { AuthProvider: AuthProvider, useAuthContext: useAuthContext, Authenticate: Authenticate, Authorize: Authorize, withAuthorize: withAuthorize };
}
export default AuthProviderFactory;
